import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportTemplates } from '../../mystudies/_study_constants';
import { TreeNode } from 'primeng/api';
import { ReportsService } from '../../services/reports.service';
import { StudyService } from '@services/study.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../../app/services/user.service';

@Component({
  selector: 'app-report-column-selection-modal',
  templateUrl: './report-column-selection-modal.component.html',
  styleUrls: ['./report-column-selection-modal.component.css'],
})
export class ReportColumnSelectionModalComponent {
  @Input() columns: string[]; // Input property to pass available columns
  //@Input() optionalColumns: string[]; // Input property to pass optional columns
  @Output() closeModalEvent = new EventEmitter<void>(); // Event emitter to close the modal
  @Output() generateReportEvent = new EventEmitter<void>(); // Event emitter to send selected columns
  @Output() cancelModalEvent = new EventEmitter<void>();
  selectedColumns: string[] = []; // Store selected columns
  sourceColumns: TreeNode[] = [];
  public reportTemplate: ReportTemplates; // coordinate variable with dialog.service.ts
  public reportOptions: any; // coordinate variable with dialog.service.ts
  public reportType: any = ReportTemplates;
  public defaultColumns: any[];
  public optionalColumns: TreeNode[];
  public selections: any[] = [];
  blockThisUI = false;
  fromDate: string;
  toDate: string;
  isSuperUser: boolean; // Add a property to store superuser status
  public reportTemplates: typeof ReportTemplates = ReportTemplates;
  showModal: boolean;
  errorMessage: string;
  optionalColumnsString: string;
  public isLegacyStudy = false;

  constructor(
    private activeModal: NgbActiveModal,
    private reportsService: ReportsService,
    private studyService: StudyService,
    private http: HttpClient,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.isSuperUser = this.userService.ensuredUser.isSuperUser;
    console.log('isSuperUser:', this.isSuperUser);
    const reportSettings = this.reportsService.getReportSettings(this.reportTemplate);
    this.defaultColumns = reportSettings.defaultColumns;
    this.sourceColumns = reportSettings.optionalColumns;
  }

  closeModal() {
    this.activeModal.close();
  }

  updateSelectedColumns(event: any) {
    /*var valueItem = event;*/
    this.selectedColumns = event.items.map((item) => item.label);
  }

  public async generateReport() {
    this.errorMessage = null;
    if (!this.isSuperUser) {
      console.log('Only accessible for superuser.');
      return;
    }

    if (!this.fromDate || !this.toDate) {
      this.errorMessage = 'Please select the Date Range.';
      return;
    }

    // Check if fromDate is later than toDate
    if (new Date(this.fromDate) > new Date(this.toDate)) {
      this.errorMessage = 'From Date cannot be later than To Date.';
      return;
    }

    await this.studyService.StudyByDateRangeReport(this.fromDate, this.toDate, this.optionalColumnsString, this.isLegacyStudy);
    this.closeModal();
  }

  cancelModal() {
    this.closeModal();
  }

  //generateReport() {
  //  this.generateReportEvent.emit(this.selectedColumns);
  //  this.closeModal();
  //}
}
